import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import de from './de.json';
import zh from './zh.json';
import fr from './fr.json';
import es from './es.json';
import nl from './nl.json';
import frCA from './fr-ca.json';

const savedLang = localStorage.getItem('lang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      zh: { translation: zh },
      fr: { translation: fr },
      es: { translation: es },
      nl: { translation: nl },
      frca: { translation: frCA },
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;